import React from 'react';
import { motion } from 'framer-motion';

const areas = [
  {
    titulo: 'Saúde emocional',
    icone: 'bi-heart-pulse',
    itens: [
      'Ansiedade',
      'Depressão',
      'Estresse e sobrecarga',
      'Esgotamento no trabalho',
      'Medos e inseguranças',
      'Luto',
      'Autoestima',
      'Autoconhecimento',
      'Compulsão alimentar',
      'Avaliação psicológica',
      'Aplicação de instrumentos e testes psicológicos',
    ],
  },
  {
    titulo: 'Relacionamentos',
    icone: 'bi-people',
    itens: [
      'Relacionamentos afetivos',
      'Conflitos nos relacionamentos',
      'Dificuldades de comunicação',
      'Mudanças e términos',
    ],
  },
  {
    titulo: 'Carreira e desenvolvimento profissional',
    icone: 'bi-briefcase',
    itens: [
      'Orientação de carreira',
      'Transição e mudanças profissionais',
      'Desenvolvimento de liderança',
      'Autoconhecimento profissional',
    ],
  },
];

export default function SubHero() {
  return (
    <section
      id="para-quem"
      className="py-5"
      style={{
        background: 'linear-gradient(to bottom right, #eef4f4, #e3eeee)',
      }}
    >
      <div className="container">
        <motion.div
          className="text-center mx-auto mb-5"
          style={{ maxWidth: '760px' }}
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <h2 className="fw-bold mb-3 text-marrom-suave" style={{ fontSize: '2rem' }}>
            Áreas de atuação
          </h2>

          <p style={{ fontSize: '1.05rem', color: '#3d4a4d', lineHeight: '1.7' }}>
            Acompanho adolescentes, adultos e idosos em diferentes momentos da vida.
            Conheça os principais temas que podemos trabalhar juntos, do cuidado com as
            emoções aos relacionamentos e à vida profissional.
          </p>

          <div
            style={{
              width: '80px',
              height: '3px',
              backgroundColor: '#c47a5f',
              margin: '1.5rem auto 0',
              borderRadius: '2px',
            }}
          />
        </motion.div>

        <div className="row g-4">
          {areas.map((area, i) => (
            <motion.div
              className="col-lg-4"
              key={area.titulo}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: i * 0.15 }}
              viewport={{ once: true }}
            >
              <div className="h-100 bg-white rounded-4 shadow-sm p-4">
                <div className="d-flex align-items-center gap-3 mb-3">
                  <i
                    className={`bi ${area.icone}`}
                    style={{ fontSize: '2rem', color: '#1f6f66' }}
                  />
                  <h3 className="h5 fw-bold text-marrom-suave mb-0">{area.titulo}</h3>
                </div>

                <ul className="list-unstyled mb-0">
                  {area.itens.map((item) => (
                    <li
                      key={item}
                      className="d-flex align-items-start gap-2 mb-2"
                      style={{ color: '#3d4a4d', lineHeight: '1.5' }}
                    >
                      <i
                        className="bi bi-check2"
                        style={{ color: '#c47a5f', fontSize: '1.1rem', lineHeight: '1.4' }}
                      />
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
